import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ujmsClerkDashboard } from "../../../services/ujmsApi";
import { Badge, cls, fmtDT, thCls, tdCls, Stat } from "../../ui";
import { SectionHdr } from "../SummaryTab";

const td = cls(tdCls, "text-[11px]");

/** Clerk desk — KPIs, filings awaiting review, recent cases & alerts (merged from the retired Clerk Dashboard). */
export function ClerkDesk() {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { ujmsClerkDashboard().then((r) => setD(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-1.5" data-testid="clerk-desk">
      <div className="grid grid-cols-3 md:grid-cols-7 gap-1" data-testid="clerk-kpis">
        <Stat label="Filings to review" value={d?.filings_awaiting_review} tone="text-orange-700" onClick={() => nav("/ujms/filings")} testId="cd-stat-filings" />
        <Stat label="Accepted today" value={d?.filings_accepted_today} tone="text-emerald-700" testId="cd-stat-accepted" />
        <Stat label="Rejected today" value={d?.filings_rejected_today} tone="text-red-700" testId="cd-stat-rejected" />
        <Stat label="Cases opened today" value={d?.cases_opened_today} testId="cd-stat-opened" />
        <Stat label="Awaiting assignment" value={d?.cases_requiring_assignment} tone="text-amber-700" onClick={() => nav("/ujms/cases?status=OPEN")} testId="cd-stat-assign" />
        <Stat label="Pending docket" value={d?.pending_docket_actions} onClick={() => nav("/ujms/docket")} testId="cd-stat-docket" />
        <Stat label="Open clerk tasks" value={d?.pending_clerk_tasks} onClick={() => nav("/ujms/tasks")} testId="cd-stat-tasks" />
      </div>
      {!!d?.alerts?.length && (
        <div className="flex flex-wrap gap-1" data-testid="clerk-alerts">
          {d.alerts.map((a, i) => <span key={i} className={cls("text-[10px] font-semibold px-1.5 leading-4 rounded-sm border", a.level === "error" ? "bg-red-50 text-red-700 border-red-200" : "bg-amber-50 text-amber-800 border-amber-200")}>{a.message || a.text || String(a)}</span>)}
        </div>
      )}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-1.5">
        <section className="ent-panel" data-testid="cd-filings-panel">
          <SectionHdr title="Filings awaiting review" right={<Link to="/ujms/filings" className="underline">Filing queue</Link>} />
          <table className="w-full border-collapse">
            <thead><tr><th className={thCls}>Received</th><th className={thCls}>Filing</th><th className={thCls}>Case</th><th className={thCls}>Filed By</th><th className={thCls}>Status</th></tr></thead>
            <tbody>
              {(d?.recent_filings || []).slice(0, 10).map((f) => (
                <tr key={f.id} className="hover:bg-ujms-soft/60 cursor-pointer" onClick={() => nav(`/cases/${f.case_id}?tab=Filings`)} data-testid={`cd-filing-${f.id}`}>
                  <td className={cls(td, "font-mono whitespace-nowrap")}>{fmtDT(f.received_at || f.created_at)}</td>
                  <td className={td}>{f.filing_title || f.title}<span className="ml-1 text-[10px] text-slate-400">{f.filing_type}</span></td>
                  <td className={cls(td, "font-mono text-ujms-dark font-semibold")}>{f.case_number}</td>
                  <td className={td}>{f.filed_by}</td>
                  <td className={td}><Badge value={f.status} /></td>
                </tr>
              ))}
              {!d?.recent_filings?.length && <tr><td colSpan={5} className={cls(td, "italic text-slate-400")}>No filings awaiting review.</td></tr>}
            </tbody>
          </table>
        </section>
        <section className="ent-panel" data-testid="cd-cases-panel">
          <SectionHdr title="Recently opened cases" right={<Link to="/ujms/intake" className="underline" data-testid="clerk-new-intake-btn">New intake</Link>} />
          <table className="w-full border-collapse">
            <thead><tr><th className={thCls}>Case</th><th className={thCls}>Caption</th><th className={thCls}>Type</th><th className={thCls}>Status</th><th className={thCls}>Judge</th></tr></thead>
            <tbody>
              {(d?.recent_cases || []).slice(0, 10).map((c) => (
                <tr key={c.id} className="hover:bg-ujms-soft/60 cursor-pointer" onClick={() => nav(`/cases/${c.id}`)} data-testid={`cd-case-${c.case_number}`}>
                  <td className={cls(td, "font-mono text-ujms-dark font-semibold whitespace-nowrap")}>{c.case_number}</td>
                  <td className={cls(td, "truncate max-w-[260px]")}>{c.caption}</td>
                  <td className={td}><Badge value={c.case_type} /></td>
                  <td className={td}><Badge value={c.status} /></td>
                  <td className={td}>{c.current_judge_name || <span className="text-amber-700 font-semibold">Unassigned</span>}</td>
                </tr>
              ))}
              {!d?.recent_cases?.length && <tr><td colSpan={5} className={cls(td, "italic text-slate-400")}>No recent cases.</td></tr>}
            </tbody>
          </table>
        </section>
      </div>
    </div>
  );
}
